import fp from "fingerprintjs2";

export const getDeviceInfo = async () => {
  const infoArray = await fp.getPromise();
  const info = {};
  infoArray.forEach(({ key, value }) => {
    info[key] = value;
  });

  return info;
};
